import yup from '../../../config/yup';

export const edfiReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('edfiReader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    debug: yup.boolean(),
    httpMethod: yup.string().oneOf(['GET', 'POST', 'PUT', 'DELETE']),
    version: yup.string(),
    requestBody: yup.string(),
    path: yup.string(),
  }),
});
